import { takeLatest, put, call, cancel } from "redux-saga/effects";
import {
  SEAT_BOOKING_GET_DATA,
  SEAT_BOOKING_GET_API,
  SEAT_BOOKING_DATA,
  SEAT_BOOKING_API,
  SEAT_BOOKING_ADD_DATA,
  SEAT_BOOKING_ADD_API,
  SEAT_BOOKING_CANCEL_DATA,
  SEAT_BOOKING_CANCEL_API,
  MY_BOOKING_GET_DATA,
  MY_BOOKING_GET_API,
  SEAT_BOOKING_TIMESLOT_DATA,
  SEAT_BOOKING_TIMESLOT_API,
} from "./Constants";
import {
  setSeatBookingGetDataSuccess,
  setSeatBookingGetDataFail,
  setSeatBookingDataSuccess,
  setSeatBookingDataFail,
  setSeatBookingAddDataSuccess,
  setSeatBookingAddDataFail,
  setSeatBookingCancelDataSuccess,
  setSeatBookingCancelDataFail,
  setMyBookingGetDataSuccess,
  setMyBookingGetDataFail,
  setSeatBookingTimeSlotDataSuccess,
  setSeatBookingTimeSlotDataFail
} from "./Actions";
import {
  getRequest,
  postRequest,
  putRequest,
} from "../../../shared/components/Service";
import { addErrorAlert, addSuccessAlert } from "../../alert/Actions";

/* ================= GET AVAILABLE SEATS ================= */

function* getSeatBookingDataService(action) {
  try {
    const { date, floor_plan_id } = action.params;
    const url = `${SEAT_BOOKING_GET_API}?date=${date}&floor_plan_id=${floor_plan_id}`;
    const response = yield call(getRequest, url);

    if (response.status === 200) {
      yield put(setSeatBookingGetDataSuccess(response.data));
    } else {
      yield put(setSeatBookingGetDataFail(response.response?.data));
    }
  } catch (error) {
    yield put(setSeatBookingGetDataFail(error));
  }
}

/* ================= GET FLOOR LIST ================= */

function* getAllSeatBookingDataService() {
  try {
    const response = yield call(getRequest, SEAT_BOOKING_API);
    if (response.status === 200) {
      yield put(setSeatBookingDataSuccess(response.data));
    } else {
      yield put(setSeatBookingDataFail(response.response?.data));
    }
  } catch (error) {
    yield put(setSeatBookingDataFail(error));
  }
}

/* ================= ADD SEAT BOOKING ================= */

function* addSeatBookingService(action) {
  try {
    const response = yield call(postRequest, SEAT_BOOKING_ADD_API, action.payload);

    if (response.status === 200 || response.status === 201) {
      yield put(setSeatBookingAddDataSuccess(response.data));
      yield put(addSuccessAlert(response.data.msg));
    } else {
      yield put(setSeatBookingAddDataFail(response.response?.data));
      yield put(addErrorAlert(response.response?.data.msg));
    }
  } catch (error) {
    yield put(setSeatBookingAddDataFail(error));
    yield put(addErrorAlert("Failed to reserve seat"));
  }
}

/* ================= CANCEL SEAT BOOKING ================= */

function* cancelSeatBookingService(action) {
  try {
    const { reservation_id } = action;
    const url = `${SEAT_BOOKING_CANCEL_API}/${reservation_id}/cancel`;

    const response = yield call(putRequest, url);

    if (response.status === 200) {
      yield put(setSeatBookingCancelDataSuccess(response.data));
      yield put(addSuccessAlert("Seat reservation cancelled"));
    } else {
      yield put(setSeatBookingCancelDataFail(response.response?.data));
      yield put(addErrorAlert("Seat cancellation failed"));
    }
  } catch (error) {
    yield put(setSeatBookingCancelDataFail(error));
    yield put(addErrorAlert("Seat cancellation failed"));
  }
}

/* ================= GET MY SEAT BOOKING ================= */

function* getMySeatBookingService() {
  try {
    const response = yield call(getRequest, MY_BOOKING_GET_API);

    if (response.status === 200 || response.status === 201) {
      yield put(setMyBookingGetDataSuccess(response.data));
     // yield put(addSuccessAlert("Seats retrived successfully"));
    } else {
      yield put(setMyBookingGetDataFail(response.response?.data));
    // yield put(addErrorAlert("Seats retrived failed"));
    }
  } catch (error) {
    yield put(setMyBookingGetDataFail(error));
    yield put(addErrorAlert("Seats retrived failed"));
  }
}

/* ================= GET FLOOR LIST ================= */

function* getAllSeatBookingTimeSlotDataService() {
  try {
    const response = yield call(getRequest, SEAT_BOOKING_TIMESLOT_API);
    if (response.status === 200) {
      yield put(setSeatBookingTimeSlotDataSuccess(response.data));
    } else {
      yield put(setSeatBookingTimeSlotDataFail(response.response?.data));
    }
  } catch (error) {
    yield put(setSeatBookingTimeSlotDataFail(error));
  }
}
/* ================= WATCHERS ================= */

export function* watchSeatBooking() {
  yield takeLatest(
    SEAT_BOOKING_GET_DATA.SEAT_BOOKING_GET_DATA_LOAD,
    getSeatBookingDataService
  );

  yield takeLatest(
    SEAT_BOOKING_DATA.SEAT_BOOKING_DATA_LOAD,
    getAllSeatBookingDataService
  );

  yield takeLatest(
    SEAT_BOOKING_ADD_DATA.SEAT_BOOKING_ADD_DATA_LOAD,
    addSeatBookingService
  );

  yield takeLatest(
    SEAT_BOOKING_CANCEL_DATA.SEAT_BOOKING_CANCEL_DATA_LOAD,
    cancelSeatBookingService
  );

  yield takeLatest(
    MY_BOOKING_GET_DATA.MY_BOOKING_GET_DATA_LOAD, 
    getMySeatBookingService
  );

  yield takeLatest(
    SEAT_BOOKING_TIMESLOT_DATA.SEAT_BOOKING_TIMESLOT_DATA_LOAD,
    getAllSeatBookingTimeSlotDataService
  );
}
